import React, { useEffect } from 'react';
import { Alert, Grid, InputLabel, TextField, Box, Typography } from '@mui/material';
import StepperHeading from '../StepperHeading';
import QuillField from '../../../../Components/QuillField';
import { AppColors } from '../../../../Utils/helper/AppColors';

const MESSAGE =
	'Note - Please do not include greetings such as "hello," "hi," or "dear," as they will be automatically fetched by the system.';

export default function CampaignEmail({ details, setDetails }) {
	const handleInputChange = (key, value) => {
		setDetails({
			...details,
			email: {
				...details?.email,
				[key]: value,
			},
		});
	};

	return (
		<Box p={3}>
			{/* <StepperHeading title="Email" subTitle="Fill in the details for the email to be sent to the employees" /> */}
			<Grid container spacing={4}>
				{/* <Grid item xs={4}>
					<InputLabel>Email Id</InputLabel>
				</Grid>
				<Grid item xs={8}>
					<TextField
						value={details?.email?.id}
						onChange={(e) => handleInputChange('id', e.target.value)}
						fullWidth
						size="small"
					/>
				</Grid> */}

				<Grid item xs={12} sx={{ '.ql-editor': { height: 100 } }}>
					<TextField
						value={details?.email?.subject}
						id="outlined-required"
						label="Subject"
						onChange={(e) => handleInputChange('subject', e.target.value)}
						InputLabelProps={{
							// shrink: true,
						}}
						fullWidth
						type="string"
						size="small"
						inputProps={{ min: 1 }}
						sx={theme => ({
							'& .MuiOutlinedInput-root': {
								'& fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&:hover fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&.Mui-focused fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
							},
						})}
					/>
				</Grid>

				{/* <Grid item xs={12}  >
					<Alert sx={{ mb: 1 }} icon={false} color="warning">
						{MESSAGE}
					</Alert>
				</Grid> */}
               {console.log('det', details)}
			   <Grid item xs={12} sx={{ '.ql-editor': { height: 100 } }}>
					<TextField
						value={details?.email?.topic}
						id="outlined-required"
						label="subTitle"
						onChange={(e) => handleInputChange('topic', e.target.value)}
						InputLabelProps={{
							// shrink: true,
						}}
						fullWidth
						type="string"
						size="small"
						inputProps={{ min: 1 }}
						sx={theme => ({
							'& .MuiOutlinedInput-root': {
								'& fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&:hover fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&.Mui-focused fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
							},
						})}
					/>
				</Grid>

				<Grid item xs={12} sm={12} md={6} sx={{ '.ql-editor': { height: 250 } }}>
					<Typography variant="caption" color={AppColors.TEXT_TERTIARY} sx={{ ml: 1, mb: 1 }}>
						Body
					</Typography>
					<QuillField value={details?.email?.body} onChange={(e) => handleInputChange('body', e)} />
				</Grid>

				<Grid item xs={12} sm={12} md={6} sx={{ '.ql-editor': { height: 250 } }}>
					<Typography variant="caption" color={AppColors.TEXT_TERTIARY} sx={{ ml: 1, mb: 1 }}>
						Signature
					</Typography>

					<QuillField value={details?.email?.signature} onChange={(e) => handleInputChange('signature', e)} />
				</Grid>

				{/* <Grid item xs={4}>
					<InputLabel>Calendar Link</InputLabel>
				</Grid>
				<Grid item xs={8}>
					<TextField
						value={details?.email?.link}
						onChange={(e) => handleInputChange('link', e.target.value)}
						fullWidth
						size="small"
					/>
				</Grid> */}

				{/* <Grid item xs={4}>
					<InputLabel>Duration</InputLabel>
				</Grid>
				<Grid item xs={8}>
					<Select
						onChange={(e) => handleInputChange('duration', e)}
						style={{ width: '50%' }}
						getPopupContainer={(node) => node.parentNode}
						defaultValue={details?.email?.duration}
						options={durations}
					/>
				</Grid> */}
			</Grid>
		</Box>
	);
}
